function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(553 362) rotate(180)"
}, React.createElement("g", {
  transform: "translate(534 343)",
  fill: "#fff",
  stroke: "#597ef7",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 19,
  height: 19,
  rx: 2,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 18,
  height: 18,
  rx: 1.5,
  fill: "none"
})), React.createElement("g", {
  transform: "translate(538.5 347.5)"
}, React.createElement("path", {
  d: "M14,10.471,10,14l-.947-.835,2.393-2.106H4V4H5.333V9.882h6.113L9.053,7.776,10,6.941Z",
  transform: "translate(-4 -4)",
  fill: "#597ef7"
})));

var SvgExport = function SvgExport(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Export.a6437fab.svg";
export { ForwardRef as ReactComponent };